import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaInicioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA INICIO' htmlFor='date-fechaInicio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaInicio'>
          {({ field }) => (
            <Form.InputDate {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='date-fechaInicio' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaInicioFormGroup)
